module.exports = __webpack_public_path__ + "media/styles/images/png/arrow-down-teal-6448e448f595235ca513e2e6c8bcf8b7.png";